import { BASE_COMPONENT } from '../../../core/wiz-base-component';
import {
  AfterViewInit, Component, Input,
  OnDestroy, ViewChild, forwardRef, ComponentRef, ChangeDetectorRef, Injector
} from '@angular/core';
import { WizBaseComponent } from '../../../core/wiz-base-component';
import { WizTextInput } from '../wiz-text-input/wiz-text-input';
import { WizTranslationBasic } from './basic/wiz-translation.basic';
import { OverlayRef } from '@angular/cdk/overlay';
import { WizFocusManager } from '../../../../services/core/focus/wiz-focus-manager';
import { ComponentPortal } from '@angular/cdk/portal';
import { WizTranslationInputPop } from './wiz-translation-input.pop';
import { IWIZ_COMPONENT} from '../../../../interfaces/iwiz-component';
import { WizEvent } from '../../../../events/wiz-event';
/**
 * Composant de saisie de libellé traductible
 * Author : SVA
 */
@Component({
  selector: 'wiz-translation',
  templateUrl: './wiz-translation-input.html',
  providers: [
    { provide: BASE_COMPONENT, useExisting: forwardRef(() => WizTranslationInput) },
    { provide: WizBaseComponent, useExisting: forwardRef(() => WizTranslationInput) },
    { provide: IWIZ_COMPONENT, useExisting: forwardRef(() => WizTranslationInput) }
  ]
})
export class WizTranslationInput extends WizTranslationBasic implements AfterViewInit, OnDestroy {

  /** le composant input principal */
  @ViewChild('mainInput', { static: true, read: WizTextInput }) declare mainInput: WizTextInput;

  // affichage ou non du label
  protected _wizShowLabel: boolean = true;
  @Input()
  public set wizShowLabel(v: boolean) {
    this._wizShowLabel = v;
    this.cdref.markForCheck();
  }
  public get wizShowLabel(): boolean {
    return this._wizShowLabel;
  }

  /**
   * Ouverture de la pop
   */
  public showPop(e: WizEvent): void {
    if (!this._popOpened) {
      const overlayRef: OverlayRef = this.overlay.create(this.getOverlayConfig());
      overlayRef.overlayElement.setAttribute('role', 'dialog');
      const injector = Injector.create({
        providers: [{ provide: ChangeDetectorRef, useValue: this.cdref },
        { provide: OverlayRef, useValue: overlayRef }],
        parent: this._injector
      });
      const translationPortal = new ComponentPortal(WizTranslationInputPop, null, injector);

      // Attach ComponentPortal to PortalHost
      const popRef: ComponentRef<WizTranslationInputPop> = overlayRef.attach(translationPortal);
      // Passage des données utiles à la pop
      popRef.instance.entryDS = this.entryDS;
      popRef.instance.parentComponent = this;
      popRef.instance.wizMaxChars = this.wizMaxChars;
      popRef.instance.maxTranslation = this.maxTranslation;
      // Déclaration de filiation au focusmanager
      WizFocusManager.getInstance().wizRegisterOwner(this.mainInput, popRef.instance.elementRef);
      // Subscribe to a stream that emits when the backdrop was clicked
      overlayRef.backdropClick().subscribe(_ => overlayRef.dispose());
      overlayRef.detachments().subscribe(_ => this.onPopClose());

      this._popOpened = true;
      // Focus au time picker
      popRef.instance.wizFocus();
    }
  }
}
